import {useCallback, useMemo, useState} from 'react';

import {InputFormik, InputProps} from '../Input';

type Props = {
    name: string;
    autoComplete?: string;
} & Partial<InputProps>;

export const PasswordInputFormik: React.FC<Props> = ({autoComplete = 'current-password', ...rest}: Props) => {
    const [visiblePassword, setVisiblePassword] = useState<boolean>(false);

    const onIconClickHandler = useCallback(() => {
        setVisiblePassword(!visiblePassword);
    }, [visiblePassword]);

    const iconName = useMemo(() => visiblePassword ? 'eye-off' : 'eye', [visiblePassword]);

    return (
        <InputFormik
            {...rest}
            type={visiblePassword ? 'text' : 'password'}
            hasEndIcon
            autoComplete={autoComplete}
            icon={iconName}
            iconProps={{
                onClick: onIconClickHandler
            }}
        />

    );
};